export const extractExceptions = ({
	exceptionsCount,
}: {
	exceptionsCount: number;
}) => {
	return exceptionsCount ?? 0;
};

export const displayValue = (count: number, isDefault: boolean | undefined) => {
	if (isDefault) return "N/A";
	return count;
};
